import api from "@/services/api";

export const state = {
  municipalities: [],
  municipality: {},
};

export const mutations = {
  INIT_MUNICIPALITIES(state, payload) {
    state.municipalities = payload;
  },
  INIT_MUNICIPALITY(state, payload) {
    state.municipality = payload;
  },
};

export const actions = {
  getMunicipalities({ commit }, payload) {
    return api.getMunicipalities(payload).then((response) => {
        commit("INIT_MUNICIPALITIES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getMunicipalityById({ commit }, payload) {
    return api.getMunicipalityById(payload).then((response) => {
      commit("INIT_MUNICIPALITY", response.data.data);
    });
  },
};

export const getters = {
  getMunicipalities: (state) => state.municipalities,
  getMunicipality: (state) => state.municipality,
};
